import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class FileInput extends PureComponent {
  handleClick() {
    // This ensures onChange will be triggered even if the user selects the same file
    this.input.value = null;
  }

  render() {
    return (
      <input
        ref={c=> this.input = c}
        type="file"
        autoComplete="off"
        accept={this.props.filetypes}
        onClick={this.handleClick.bind(this)}
        onChange={this.props.onChange}
      />
    );
  }
}

FileInput.defaultProps = {
  filetypes: '*'
};

FileInput.propTypes = {
  filetypes: PropTypes.string,
  onChange: PropTypes.func
};

export default FileInput;
